import type { FeatureGateSeed } from './feature-gate-registry';

/**
 * Tasks from this reply gates (docs/plans/2026-10-21-feat-tasks-from-reply-commitments-plan.md,
 * R13 and R53), spread into FEATURE_GATE_SEEDS in feature-gate-registry.ts at their place in the
 * admin page order. The rows are created by the draft_commitment_tasks_gates migration.
 */
export const DRAFT_COMMITMENT_FEATURE_GATE_SEEDS = {
  draft_commitment_tasks: {
    label: 'Tasks from this reply',
    shortLabel: 'Reply tasks',
    description:
      'Detects what a reply draft promises and shows each promise as a task beside the draft. Offices start with detected tasks unticked; tasks are not created yet.',
    group: 'pulse_ai',
  },
  draft_commitment_tasks_tracking: {
    label: 'Tasks from this reply: ticked by default',
    shortLabel: 'Reply tasks ticked',
    description:
      'Detected tasks start ticked instead of unticked. Turn on for an office only once its detection quality meets the bar. Needs Tasks from this reply as well.',
    group: 'pulse_ai',
  },
} satisfies Record<string, FeatureGateSeed>;
